import { getAccessToken } from './authToken';

const apiBaseUrl = process.env.REACT_APP_API_URL;


// Ahora manda `Authorization: Bearer <access token de Auth0>` en vez de la API key
// compartida. El token lo valida el backend (`src/utils/auth.py`: RS256, `iss`,
// `aud` y expiracion contra el JWKS).
//
// OJO con el cambio a `async`: la funcion tiene que esperar al token antes de
// disparar el fetch. Los 63 call sites ya hacen `await fetchBackend(...)`, asi
// que ninguno se entera. Si alguno hiciera `resp.json()` sin await sobre el valor
// devuelto, pasaria a recibir una Promise en vez de una Response.
const fetchBackend = async ( endpoint, data, method = 'GET' ) => {

    const url = `${ apiBaseUrl }/${ endpoint }`;

    const accessToken = await getAccessToken();

    const headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${ accessToken }`,
    };

    if ( method === 'GET' ) {
        return fetch( url, { headers } );
    } else {
        return fetch( url, {
            method,
            headers,
            body: JSON.stringify( data )
        });
    }
}



export {
    fetchBackend,
    apiBaseUrl
}
